import { render } from "./BaseContentContainer.vue?vue&type=template&id=4c5479c2&scoped=true"
const script = {}

import "./BaseContentContainer.vue?vue&type=style&index=0&id=4c5479c2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4c5479c2"

export default script